import { styled } from '../../Styles/stitches.config'

export const StyledConfirmation = styled('div', {
    display: 'grid',
    w: '100%',
    textAlign: 'center',
    justifyItems: 'center',
    p: '$4',
    gap: '$2',
    variants: {
        size: {
            1: {
                fontSize: '2.986rem',
            },
            2: {
                fontSize: '2.488rem',
            },
            3: {
                fontSize: '2.074rem',
            },
            4: {
                fontSize: '1.728rem',
            },
            5: {
                fontSize: '1.44rem',
            },
            6: {
                fontSize: '1.2rem',
            },
        },
    },
})

export const StyledIcon = styled(StyledConfirmation, {
    p: '$0',
    '>*': {
        color: '$secondary500',
        textAlign: 'center',
        variants: {
            iconSize: {
                1: {
                    fontSize: 81,
                },
                2: {
                    fontSize: 71,
                },
                3: {
                    fontSize: 61,
                },
                4: {
                    fontSize: 51,
                },
                5: {
                    fontSize: 41,
                },
                6: {
                    fontSize: 31,
                },
            },
        },
    },
})
